module.exports = " <div> <router-view></router-view> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./~/eslint-loader!./src/App.vue
// module id = 161
// module chunks = 2